export function hasDuplicateValuesByProperty(arr: any[], key: string) {
    const values = new Set();
    let hasDuplicates = false;

    arr.forEach((item) => {
        if (!values.has(item[key])) {
            values.add(item[key]);
        }
    });

    if (values.size > 1) {
        hasDuplicates = true;
    }

    return hasDuplicates;
}
